<template>
    <div class="wrapper" style="
        background: url(https://cdn.shopify.com/s/files/1/0905/2012/files/station-h8.jpg?v=1631259836)
            no-repeat center;
    ">
        <div class="container">
            <div class="row mb_80 ApRow has-bg bg-fullwidth-container" style>
                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 col-sp-12 ApColumn">
                    <div class="block text-flex-2 ApHtml">
                        <h4 class="title_block">
                            Open up to a new
                            experience.
                        </h4>
                        <div class="sub-title-widget">
                            100% Stationery product
                        </div>
                        <div class="block_content">
                            <div>
                                <a href="/products">all collections
                                    <i class="fal fa-arrow-right"></i></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>